import { alpha } from '@mui/material'
import { COLORS } from '../../../styles/variables'

export const HIGHLIGHT_HOLD_MS = 1000
export const HIGHLIGHT_FADE_MS = 1000

export function getCommentHighlightRowSx(isHighlighted: boolean) {
  return {
    borderRadius: 1,
    transition: `background-color ${HIGHLIGHT_FADE_MS}ms ease`,
    backgroundColor: isHighlighted ? alpha(COLORS.CERULEAN, 0.12) : 'transparent',
  }
}
